import React, { useState } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { FaWhatsapp, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaRegCommentDots,FaFacebook } from 'react-icons/fa';
import { sendContactEmail } from '../lib/emailService';
import './contact.css';
 
function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
 
  const [formStatus, setFormStatus] = useState('');
 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();

    setFormStatus('sending');

    const messageToSend = formData.subject
      ? `Subject: ${formData.subject}\n\n${formData.message}`
      : formData.message;

    try {
      await sendContactEmail({
        name: formData.name,
        email: formData.email,
        message: messageToSend,
      });

      setFormStatus('success');
      setTimeout(() => {
        setFormStatus('');
        setFormData({ name: '', email: '', subject: '', message: '' });
      }, 3000);
    } catch (error) {
      console.error('There was an error sending the email!', error);
      setFormStatus('error');
      setTimeout(() => {
        setFormStatus('');
      }, 3000);
    }
  };
 
  return (
    <div>
      <section className="contact-page">
        <div className="contact-wrap">
          <div className="contact-hero">
            <div className="contact-hero-left">
              <div className="contact-pill">
                <span>Contact Us</span>
              </div>
              <h1 className="contact-title">Get In Touch</h1>
              <p className="contact-subtitle">
                Ready to discuss your engineering project? Reach out to Divine-Tech Engineering (DTE) for water systems installation, maintenance, fabrication, and technical support.
              </p>
              <a href="tel:0881816790" className="contact-cta">
                <span>Call Now</span>
              </a>
            </div>
            <div className="contact-hero-right">
              <img
                className="contact-hero-image"
                src="/images/42.jpg"
                alt="Contact Divine-Tech Engineering"
              />
            </div>
          </div>
 
          <div className="contact-content">
            <div className="contact-grid">
              <div className="contact-card contact-form-card">
                <div className="contact-card-icon" aria-hidden="true">
                  <FaRegCommentDots />
                </div>
                <h3 className="contact-card-title">Let’s Start a Conversation</h3>
                <p className="contact-card-subtitle">Tell us what you need and we’ll get back to you.</p>
 
                <Form onSubmit={handleSubmit} className="contact-form">
                  <Row>
                    <Col md={6}>
                      <Form.Group controlId="formName" className="mb-3">
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Your Name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          className="contact-input"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formEmail" className="mb-3">
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="Email Address"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          className="contact-input"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
 
                  <Form.Group controlId="formSubject" className="mb-3">
                    <Form.Control
                      type="text"
                      name="subject"
                      placeholder="What’s this about?"
                      value={formData.subject}
                      onChange={handleChange}
                      className="contact-input"
                    />
                  </Form.Group>
 
                  <Form.Group controlId="formMessage" className="mb-3">
                    <Form.Control
                      as="textarea"
                      rows={5}
                      name="message"
                      placeholder="Tell us more about your project..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                      className="contact-input"
                    />
                  </Form.Group>
 
                  <Button type="submit" className="contact-submit" disabled={formStatus === 'sending'}>
                    {formStatus === 'sending' ? 'Sending…' : 'Send Message'}
                  </Button>
 
                  {formStatus === 'success' && (
                    <div className="contact-form-status contact-form-status--success" role="status">
                      Message sent successfully.
                    </div>
                  )}
 
                  {formStatus === 'error' && (
                    <div className="contact-form-status contact-form-status--error" role="status">
                      Failed to send message. Please try again.
                    </div>
                  )}
                </Form>
              </div>
 
              <div className="contact-right">
                <h3 className="contact-right-title">Ready to Transform Your Ideas?</h3>
                <p className="contact-right-text">
                  Contact person: Zeka King Banda. We support both rural and urban clients with reliable, field-proven engineering solutions.
                </p>
 
                <div className="contact-info-list">
                  <a className="contact-info-card contact-info-card--email" href="mailto:zekakbanda@gmail.com">
                    <span className="contact-info-icon" aria-hidden="true"><FaEnvelope /></span>
                    <span>
                      <span className="contact-info-title">Email Us</span>
                      <span className="contact-info-main">zekakbanda@gmail.com</span>
                      <span className="contact-info-sub">Response in 1–2 business days</span>
                    </span>
                  </a>
 
                  <a className="contact-info-card contact-info-card--phone" href="tel:0881815790">
                    <span className="contact-info-icon" aria-hidden="true"><FaPhoneAlt /></span>
                    <span>
                      <span className="contact-info-title">Call Us</span>
                      <span className="contact-info-main">+265 881 816 790</span>
                      <span className="contact-info-sub">Available Mon–Sat</span>
                    </span>
                  </a>
 
                  <div className="contact-info-card contact-info-card--office" role="note">
                    <span className="contact-info-icon" aria-hidden="true"><FaMapMarkerAlt /></span>
                    <span>
                      <span className="contact-info-title">Visit Our Office</span>
                      <span className="contact-info-main">Box 192, Mponela, Malawi</span>
                      <span className="contact-info-sub">On-site visits by arrangement</span>
                    </span>
                  </div>
                </div>
 
                <div className="contact-stats">
                  <div className="contact-stat">
                    <div className="contact-stat-value">24h</div>
                    <div className="contact-stat-label">Average Response</div>
                  </div>
                  <div className="contact-stat">
                    <div className="contact-stat-value">98%</div>
                    <div className="contact-stat-label">Client Satisfaction</div>
                  </div>
                  <div className="contact-stat">
                    <div className="contact-stat-value">150+</div>
                    <div className="contact-stat-label">Projects Delivered</div>
                  </div>
                </div>
              </div>
            </div>
 
            <div className="contact-social">
              <div className="contact-social-title">Connect With Us</div>
              <div className="contact-social-links">
                <a href="https://wa.me/0995543765" target="_blank" rel="noopener noreferrer" className="contact-social-link" aria-label="WhatsApp">
                  <FaWhatsapp />
                </a>
                <a href="mailto:zekakbanda@gmail.com" className="contact-social-link" aria-label="Email">
                  <FaEnvelope />
                </a>
                <a href="tel:0881816790" className="contact-social-link" aria-label="Phone">
                  <FaPhoneAlt />
                </a>
                <a href="https://www.facebook.com/divinetechtechnologies" target="_blank" rel="noopener noreferrer" className="contact-social-link" aria-label="Facebook">
                  <FaFacebook />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
 
export default ContactUs;
 
 